<template>
  <div v-loading="loading">
    <div v-if="isPlatform" style="height: 500px">
      平台化商家不能参与小店分发项目
    </div>
    <!-- 平台化设置 -->
    <el-form
      v-if="!isPlatform"
      ref="storeDis"
      :model="form"
      label-width="140px"
      :rules="formDataRules"
      :show-message="storeInOpen"
      :hide-required-asterisk="storeInClose"
    >
      <el-form-item
        label="是否参与小店分发"
        prop="is_participation_dispense"
        label-width="140px"
      >
        <el-select
          v-model="form.is_participation_dispense"
          @change="handleChange"
        >
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="2"></el-option>
        </el-select>
        <span v-show="storeInClose" class="select-option-tips">
          成功“关闭”后，所有设置失效，开单不会扣除佣金。
        </span>
      </el-form-item>
      <el-card class="shop-card" shadow="never">
        <el-form-item
          label="协议生效日期"
          prop="effective_date"
          label-width="140px"
        >
          <el-row>
            <el-col :span="8">
              <el-date-picker
                v-model="form.effective_date"
                type="date"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                :disabled="storeInClose"
              ></el-date-picker
            ></el-col>
            <el-col :span="12">
              <span v-show="form.effective_date" class="select-option-tips">
                从<span class="tip">{{ nextDay }} 7:00的</span
                >专场日起，只要参与「小店渠道分发」所生成的采购计划（<span
                  class="tip"
                  >{{ afterTomorrow }} 7:00起</span
                >），在开单中每件商品都将会被扣除X%的「小店佣金服务费」。前置仓账单、买赔账单同理在<span
                  class="tip"
                  >{{ afterTomorrow }} 7:00起</span
                >对生产的账单进行扣佣。
              </span></el-col
            >
          </el-row>
        </el-form-item>
        <el-form-item label="抽佣比例" prop="checkList">
          <el-checkbox-group v-model="form.checkList">
            <div class="checkbox-wrap">
              <el-checkbox
                v-model="form.checked_normal_rate"
                :disabled="storeInClose"
                label="normal_rate"
              >
                <span class="tip">正价</span>抽佣比例
              </el-checkbox>
              <ys-input
                v-model="form.normal_rate"
                pattern="positiveInt"
                min="1"
                max="100"
                :disabled="
                  !form.checkList.includes('normal_rate') || storeInClose
                "
                :style="{ width: '200px', marginLeft: '8px' }"
                placeholder="采购单商品抽佣比例"
              >
                <template slot="append"> % </template>
              </ys-input>
            </div>
            <div class="checkbox-wrap second">
              <el-checkbox
                v-model="form.checked_special_offer_rate"
                :disabled="storeInClose"
                label="special_offer_rate"
              >
                <span class="tip">特价</span>抽佣比例
              </el-checkbox>
              <ys-input
                v-model="form.special_offer_rate"
                pattern="positiveInt"
                min="1"
                max="100"
                :disabled="
                  !form.checkList.includes('special_offer_rate') || storeInClose
                "
                :style="{ width: '200px', marginLeft: '8px' }"
                placeholder="采购单商品抽佣比例"
              >
                <template slot="append"> % </template>
              </ys-input>
            </div>
          </el-checkbox-group>
        </el-form-item>
      </el-card>
      <el-button
        type="primary"
        style="margin-top: 20px; margin-left: 800px"
        @click="handleSubmit"
        >提交</el-button
      >
    </el-form>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import dayjs from "dayjs";
import {
  getDispenseSetting,
  updateDispenseSetting,
} from "@/controller/supply2267.js";

// 小店分发设置状态
const OPEN_STATUS = "1";
const CLOSE_STATUS = "2";

export default {
  props: {
    supplyId: {
      type: String,
      default: "0",
    },
  },

  data() {
    const validateType = (rule, value, callback) => {
      const valueLen = value.length;
      if (valueLen > 0) {
        callback();
      } else {
        callback(new Error("商品抽佣比例最少选一个"));
      }
    };

    const initForm = {
      supply_id: this.supplyId,
      checkList: [],
      is_participation_dispense: "2", // 关闭
    };

    return {
      loading: false,
      isPlatform: false,
      initForm,
      form: initForm,
      formDataRules: {
        effective_date: [
          {
            required: true,
            message: "请选择协议生效日期",
            trigger: "blur",
          },
        ],
        checkList: {
          required: true,
          validator: validateType,
          trigger: "blur",
        },
      },
      pickerOptions: {
        disabledDate: (date) => date.getTime() < Date.now() - 86400000,
      },
    };
  },

  computed: {
    storeInOpen() {
      return this.form.is_participation_dispense === OPEN_STATUS;
    },
    storeInClose() {
      return this.form.is_participation_dispense === CLOSE_STATUS;
    },
    nextDay() {
      return dayjs(this.form.effective_date)
        .add(1, "days")
        .format("YYYY-MM-DD");
    },
    afterTomorrow() {
      return dayjs(this.form.effective_date)
        .add(2, "days")
        .format("YYYY-MM-DD");
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      getDispenseSetting({ supply_id: this.supplyId }).then((res) => {
        const {
          shop_dispense_setting: shopDispenseSetting,
          no_reason_return: isPlatform,
        } = res;
        console.log(isPlatform, "isPlatform");
        if (isPlatform) {
          this.isPlatform = true;
          return;
        }
        const checks = [];
        if (shopDispenseSetting.normal_rate > 0) {
          checks.push("normal_rate");
        }
        if (shopDispenseSetting.special_offer_rate > 0) {
          checks.push("special_offer_rate");
        }
        this.form = {
          ...this.form,
          ...shopDispenseSetting,
          checkList: checks,
        };
      });
    },

    handleSubmit() {
      this.$refs.storeDis.validate((validate) => {
        const {
          checkList,
          special_offer_rate: specialOfferRate,
          normal_rate: normalRate,
          is_participation_dispense: isParticipationDispense,
          ...rest
        } = this.form;
        // 表单校验
        if (!validate && this.storeInOpen) {
          return;
        }
        this.loading = true;
        const params = {
          ...rest,
          is_participation_dispense: isParticipationDispense,
          special_offer_rate: checkList.includes("special_offer_rate")
            ? specialOfferRate
            : "",
          normal_rate: checkList.includes("normal_rate") ? normalRate : "",
        };
        updateDispenseSetting(params)
          .then(() => {
            this.$message.success("保存成功");
            this.fetchData();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleChange() {
      // 关闭个性化时 清空数据
      if (this.storeInClose) {
        this.form = cloneDeep(this.initForm);
      }
    },
  },
};
</script>

<style scoped>
.shop-card {
  width: 1000px;
}
.shop-card .el-card__body {
  padding: 12px;
}
.checkbox-wrap {
  display: flex;
  align-items: center;
}
.checkbox-wrap.second {
  margin-top: 8px;
}

.select-option-tips {
  line-height: 1;
  color: #606266;
}
.tip {
  color: blue;
}
</style>


// WEBPACK FOOTER //
// src/pages/supply/updateSupplyComponents/StoreDistribute.vue